import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { SUBMISSION_TYPES } from '@src/constants/element-types';
import {
  updateCampaignElementValue
} from '@src/redux/modules/campaignLandingPage';

import VideoCollector from '@src/components/CampaignLanding/VideoCollector';
import ImageCollector from '@src/components/CampaignLanding/ImageCollector';
import TextCollector from '@src/components/CampaignLanding/TextCollector';
import styles from '@src/components/CampaignLanding/DynamicCollectors.module.less';

const DEFAULT_TYPE_LABELS = {
  [SUBMISSION_TYPES.VIDEO]: 'Record or Upload Video',
  [SUBMISSION_TYPES.IMAGE]: 'Upload Image',
  [SUBMISSION_TYPES.TEXT]: 'Write your response'
};

const DynamicCollectors = ({
  qid,
  selectedTypes,
  element,
  campaignElements,
  organizationId,
  _updateCampaignElementValue
}) => {
  const elementData = campaignElements[qid] || {};
  const typeLabels = element?.typeLabels || {};
  const typeDescriptions = element?.typeDescriptions || {};

  const handleVideoChange = (videoData) => {
    _updateCampaignElementValue({
      qid,
      value: {
        ...elementData.value,
        video: videoData
      }
    });
  };

  const handleImageChange = (imageData) => {
    _updateCampaignElementValue({
      qid,
      value: {
        ...elementData.value,
        image: imageData
      }
    });
  };

  const handleTextChange = (textData) => {
    _updateCampaignElementValue({
      qid,
      value: {
        ...elementData.value,
        text: textData
      }
    });
  };

  return (
    <Stack spacing={2} className={styles.vpDynamicCollectorsContainer}>
      {selectedTypes.includes(SUBMISSION_TYPES.VIDEO) && (
        <Box className={styles.vpCollectorWrapper}>
          <VideoCollector
            qid={qid}
            value={elementData.value?.video}
            onChange={handleVideoChange}
            required={true}
            element={element}
            label={typeLabels[SUBMISSION_TYPES.VIDEO] || DEFAULT_TYPE_LABELS[SUBMISSION_TYPES.VIDEO]}
            description={typeDescriptions[SUBMISSION_TYPES.VIDEO] || ''}
          />
        </Box>
      )}

      {selectedTypes.includes(SUBMISSION_TYPES.IMAGE) && (
        <Box className={styles.vpCollectorWrapper}>
          <ImageCollector
            value={elementData.value?.image}
            onChange={handleImageChange}
            required={true}
            organizationId={organizationId}
            label={typeLabels[SUBMISSION_TYPES.IMAGE] || DEFAULT_TYPE_LABELS[SUBMISSION_TYPES.IMAGE]}
            description={typeDescriptions[SUBMISSION_TYPES.IMAGE] || ''}
          />
        </Box>
      )}

      {selectedTypes.includes(SUBMISSION_TYPES.TEXT) && (
        <Box className={styles.vpCollectorWrapper}>
          <TextCollector
            value={elementData.value?.text}
            onChange={handleTextChange}
            required={true}
            label={typeLabels[SUBMISSION_TYPES.TEXT] || DEFAULT_TYPE_LABELS[SUBMISSION_TYPES.TEXT]}
            description={typeDescriptions[SUBMISSION_TYPES.TEXT] || ''}
          />
        </Box>
      )}
    </Stack>
  );
};

DynamicCollectors.propTypes = {
  qid: PropTypes.string.isRequired,
  selectedTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  element: PropTypes.object,
  campaignElements: PropTypes.object,
  organizationId: PropTypes.string,
  _updateCampaignElementValue: PropTypes.func
};

const mapDispatchToProps = {
  _updateCampaignElementValue: updateCampaignElementValue
};

export default connect(null, mapDispatchToProps)(DynamicCollectors);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/DynamicCollectors.jsx